import { whatsappLink } from "../../utils/whatsapp";

export const FooterComponent = () => {
    const currentYear = new Date();


    return (<footer className="text-center text-lg-start text-light" style={{ "backgroundColor": "#000" }}>
        <div className="container">

            <section
                className="d-flex justify-content-between p-4"                >
                <div className="me-5">
                    <span>Entre em contato conosco pelas redes sociais:</span>
                </div>
                <div>
                    <a href="https://www.facebook.com/lightconsistemaconstrutivo/" target="_blank" className="text-white me-4">
                        <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="https://instagram.com/lightconbrasil" target="_blank" className="text-white me-4">
                        <i className="fab fa-instagram"></i>
                    </a>
                    <a href={whatsappLink} target="_blank" className="text-white me-4">
                        <i className="fab fa-whatsapp"></i>
                    </a>
                </div>
            </section>

            <section className="">
                <div className="row justify-content-center text-md-start mt-3">
                    {/* <div className="col-md-4 col-lg-4 col-xl-3 mx-auto mb-4">
                            <h6 className="text-uppercase fw-bold">LIGHTCON</h6>
                            <hr
                                className="mb-4 mt-0 d-inline-block mx-auto"
                            />
                            <p>
                                Here you can use rows and columns to organize your footer
                                content. Lorem ipsum dolor sit amet, consectetur adipisicing
                                elit.
                            </p>
                        </div> */}

                    <div className="col-xl-4 mx-auto mb-6"></div>

                    <div className="col-md-12 col-lg-2 col-xl-4 mx-auto mb-4">
                        <h6 className="mb-3">LIGHTCON - CONTATO</h6>
                        <p><i className="fas fa-home mr-3"></i> Franca, SP</p>
                        <a href="mailto:contato@lightcon.com.br" style={{textDecoration: "none", color: "#fff" }}><i className="fas fa-envelope"></i> contato@lightcon.com.br</a>
                    </div>

                    <div className="col-xl-2 mx-auto mb-4"></div>

                    {/* <div className="col-md-4 col-lg-3 col-xl-3 mx-auto mb-md-0 mb-4">
                            <h6 className="text-uppercase fw-bold">Contact</h6>
                            <hr
                                className="mb-4 mt-0 d-inline-block mx-auto"
                            />
                            <p><i className="fas fa-home mr-3"></i> Franca, São Paulo, (Endereço)</p>
                            <p><i className="fas fa-envelope mr-3"></i> contato@lightcon.com.br</p>
                            <p><i className="fas fa-phone mr-3"></i> + 01 234 567 88</p>
                            <p><i className="fas fa-print mr-3"></i> + 01 234 567 89</p>
                        </div> */}
                </div>
            </section>

            <div
                className="col-12 text-center p-3"
            >
                ©{currentYear.getFullYear()} Copyright
            </div>

        </div>
    </footer>);
}